module.exports = __webpack_public_path__ + "e86bf73850bff101542f6bccd8752741.svg";